<nz-modal [(nzVisible)]="isVisible" [nzTitle]="null" [nzContent]="modalContent" [nzFooter]="null" [nzWidth]="900"
    [nzClosable]="false">
    <nz-spin [nzSpinning]="isSpinning">
        <ng-template #modalContent>
            <nz-table [nzLoading]="loading">
                <div nz-row>
                    <div nz-col nzXs="24" nzLg="24" nzXl="24" class="text-left">
                        <div class="title-text-model sub-header-font-size">{{'J0000.J0012' | translate}} :
                            {{referenceNo}}
                        </div>
                    </div>
                </div>
                <div nz-row>
                    <div nz-col nzXs="7" nzLg="7" nzXl="7" class="text-right">
                        <div class="label-input body-font-size">{{'J0000.J0025' | translate}} : </div>
                    </div>
                    <nz-form-item nz-col nzXs="16" nzLg="16" nzXl="16" class="text-left">
                        <nz-form-control nzErrorTip="">
                            <nz-radio-group class="ant-radio-group-swict body-font-size" nzButtonStyle="solid"
                                [(ngModel)]="docType">
                                <label nz-radio-button nzValue="1">{{'J0000.J0026' | translate}}</label>
                                <label nz-radio-button nzValue="2">{{'J0000.J0027' | translate}}</label>
                                <!-- <label nz-radio-button nzValue="3">{{'J0000.J0031' | translate}}</label> -->
                            </nz-radio-group>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-row>
                    <div nz-col nzXs="7" nzLg="7" nzXl="7" class="text-right">
                        <div class="label-input body-font-size">{{'J0000.J0028' | translate}} : </div>
                    </div>
                    <div nz-col nz-col nzXs="16" nzLg="16" nzXl="16" class="text-left">
                        <nz-upload [(nzFileList)]="fileList" [nzBeforeUpload]="beforeUpload">
                            <input nz-col nzXs="19" nzLg="18" nzXl="18" class="input-radius body-font-size" nz-input
                                readonly />
                            <button class="upload-button search-button body-font-size" nz-button nzType="primary">
                                <i class="upload-icon" nz-icon nzType="folder-open" nzTheme="fill"></i>
                            </button>
                        </nz-upload>
                    </div>
                </div>
                <div nz-row class="line" style="border-bottom: 1px solid; margin-bottom:5px;">
                    <div nz-col nzXs="24" nzLg="24" nzXl="24" class="text-center">
                        <div class="worning-text body-font-size">* {{'J0000.J0013' | translate}}</div>
                    </div>
                </div>
                <div nz-row *ngFor="let item of fileList; let i = index">
                    <div nz-col nzXs="2" nzLg="2" nzXl="2"></div>
                    <div nz-col nzXs="20" nzLg="20" nzXl="20" class="hover">
                        <div nz-row>
                            <div nz-col nzXs="18" class="text-left">
                                <div class="file-list-text body-font-size">{{item.name}}</div>
                            </div>
                            <div nz-col nzXs="6" class="text-right">
                                <div class="file-size-text body-font-size">
                                    {{ convertByteToMB(item.size) | number:'0.2-2'}}
                                    MB
                                    <i nz-icon style="margin-left: 6px;" (click)="deleteUploadFile(i)" nz-tooltip
                                        nzTooltipTitle="{{'J0000.J0030' | translate}}" nzTooltipPlacement="right"
                                        nzType="delete" nzTheme="fill" class="icon-delete"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div nz-col nzXs="2" nzLg="2" nzXl="2"></div>
                </div>
                <nz-alert [hidden]="correctFileType" nzType="error"
                    nzDescription="สามารถเพิ่มไฟล์ได้ แค่ .png .jpg .jpeg .pdf เท่านั้น กรุณาเลือกไฟล์ใหม่" nzShowIcon>
                </nz-alert>
                <nz-alert [hidden]="!overSize" nzType="error" nzDescription="{{ 'rejectAddFile10' | translate}}"
                    nzShowIcon> </nz-alert>
                <div nz-row class="mt-4">
                    <div nz-col nzSpan="12" class="pr-1">
                        <div class="btn-wrapper body-font-size" style="text-align: right;">
                            <div id="btn-upload" (click)="uploadFile()"
                                [ngClass]="fileList.length == 0 ? 'btn-gray' : 'btn-blue'"
                                class="btn-styles text-center" style="cursor: pointer;">
                                <div class="txt">
                                    <button class="body-font-size" type="button"
                                        style="cursor: pointer;">{{'J0000.J0014' | translate}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div nz-col nzSpan="12" class="pl-1">
                        <div class="btn-wrapper body-font-size" style="text-align: left;">
                            <div id="btn-close" (click)="close()" class="btn-styles btn-orange text-center"
                                style="cursor: pointer;">
                                <div class="txt">
                                    <button class="body-font-size" type="button"
                                        style="cursor: pointer;">{{'J0000.J0015' | translate}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nz-table>
        </ng-template>
    </nz-spin>
</nz-modal>